import type { Coach } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (coaches?: Coach[]) => {
  useRegisterAgentContext({
    kind: 'list',
    description: 'Available coaches the user can view and book consultations with',
    data: coaches ?? [],
  });
};
